module.exports = __webpack_public_path__ + "img/bg_sev_b.70140e5a.jpg";